import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-xl border border-[color:var(--ug-field-border)] bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none ug-focus-glow focus-visible:ring-2 focus-visible:ring-[color:var(--ug-focus)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      data-ug="input"
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
